import { accountAccessShowLogin } from 'actions/UiActions'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import { RouteChildrenProps, RouteProps } from 'react-router'
import usePrevious from 'hooks/usePrevious'
import { isLoggedIn } from 'selectors/accountSelectors'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'

interface Props extends RouteChildrenProps, Pick<RouteProps, 'children' | 'render' | 'component'> {
  isLoggedIn: boolean;
  loggingIn: boolean;
  regionCode: string;
  showPopup?: boolean;
  modalOpen?: boolean;
}

function AuthRouteComponent(props: Props) {
  const {
    isLoggedIn,
    loggingIn,
    modalOpen,
    regionCode,
    component: Component,
    showPopup,
    children,
    render,
    ...rest
  } = props
  const { match } = props
  const dispatch = useAppDispatch()
  const [loginDismissed, setLoginDismissed] = useState<boolean>(false)
  const prevModalOpen = usePrevious(modalOpen)

  const path = match?.path

  useEffect(() => {
    if (showPopup && !isLoggedIn) {
      if (path?.startsWith('/:regionCode/trip-planner/trip/')) {
        dispatch(accountAccessShowLogin('tripPlannerLogin'))
      } else {
        dispatch(accountAccessShowLogin())
      }
    }
  }, [dispatch, isLoggedIn, showPopup, path])

  useEffect(() => {
    if (prevModalOpen && !modalOpen) {
      setLoginDismissed(true)
    }
  }, [modalOpen, prevModalOpen])

  if (!isLoggedIn && (loggingIn || (showPopup && !loginDismissed))) {
    return <LoadingIndicator />
  }

  if (!isLoggedIn && (!showPopup || (showPopup && loginDismissed))) {
    // try going back to where we came from, otherwise - go to homepage
    return <RedirectWithStatus code={302} to={`/${regionCode.toLowerCase()}`}/>
  }

  if (Component) {
    return <Component {...rest} />
  }

  if (render) {
    return <>{render(rest)}</>
  }

  return <>{children}</>
}

function mapStateToProps(state: App.State) {
  return {
    isLoggedIn: isLoggedIn(state),
    loggingIn: state.auth.processing,
    modalOpen: (state.ui.modal.modalType === 'accountAccess' && state.ui.modal.open),
    regionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(AuthRouteComponent)
